module.exports = __webpack_public_path__ + "src/assets/textures/env/well/well_1k_bake.png";